import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { LayoutServiceDataExtensions } from './shared.types';

export const useCustomSitecoreContext = () => {
  const { sitecoreContext } = useSitecoreContext();
  const context = sitecoreContext as LayoutServiceDataExtensions['context'];
  return context;
};
